export default __webpack_public_path__ + "static/media/logo18.8c8c9c5c.png";